import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { GET_MAINTENANCE_FILE_IDS_BY_DATE } from 'api/queries/csvService';
import { MaintenanceFile } from 'types/csvService';

export class CsvStore {
  // eslint-disable-next-line class-methods-use-this
  async getMaintenanceFileIdsByDate(from: string, to: string, fullView: boolean): Promise<MaintenanceFile[]> {
    const res = await apolloClient.query<{ getMaintenanceFileIdsByDate: MaintenanceFile[] }>({
      query: GET_MAINTENANCE_FILE_IDS_BY_DATE,
      fetchPolicy: 'no-cache',
      variables: { from, to, fullView },
    });
    return res.data.getMaintenanceFileIdsByDate;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
